module.exports = __webpack_public_path__ + "img/productPage.a8ebc2ef.jpg";